module.exports = __webpack_public_path__ + "img/prot-7000.a7ab5578.png";